export default {
  documento: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  nome: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  celular: {
    value: '',
    maxlength: '15',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/campaignlist/components/add/modal/contactmodal/contact-form.js